<po-page-default
  [p-breadcrumb]="breadcrumb"
  p-title="Controle de Qualidade - Cadastro"
>
  <po-input
    [p-auto-focus]="true"
    class="po-md-12"
    name="etiqueta"
    [(ngModel)]="etiqueta"
    p-label="Etiqueta"
    (keyup.enter)="biparEtiqueta()"
  >
  </po-input>

  <h1 class="po-md-12 po-font-subtitle po-mb-1 po-mt-3">Etiquetas Bipadas</h1>
  <div class="po-row">
    <po-table class="po-sm-12 po-md-12 po-lg-12"
      [p-striped]="true"
      [p-items]="controleQualidade.items"
      [p-columns]="colunas"
      p-spacing="small"
      [p-filter-type]="poSearchFilterMode"
      p-hide-table-search="false"
    ></po-table>
  </div>

  <div class="po-row">
    <po-button
      p-label="Aprovar"
      class="po-xl-3 po-md-12 po-mt-2"
      (p-click)="aprovarEtiquetas()"
      p-kind="primary"
    >
    </po-button>
    <po-button
      p-label="Reprovar"
      class="po-xl-3 po-md-12 po-mt-2"
      (p-click)="modalReprovarOpen()"
      p-kind="secondary"
    >
    </po-button>

    <h1 class="po-md-12 po-font-subtitle po-mb-1 po-mt-3">Bipadas Hoje pelo Usuário</h1>
    <div class="po-row">
      <po-table class="po-sm-12 po-md-12 po-lg-12"
        [p-striped]="true"
        [p-items]="bipadasHoje"
        [p-columns]="colunasBipadas"
        p-spacing="small"
        [p-filter-type]="poSearchFilterMode"
        p-hide-table-search="false"
      ></po-table>
    </div>
  </div>

</po-page-default>

<po-modal #reprovarModal p-title="Reprovar" [p-primary-action]="reprovarAction">
    <form #f="ngForm">
      <po-lookup
        class="po-md-12"
        name="motivo"
        [(ngModel)]="controleQualidade.motivo"
        p-label="Motivo da Reprovação"
        p-field-value="CZPRCHAVE"
        p-field-label="CZPRGENERI"
        [p-columns]="zprColumnsFilters"
        [p-field-format]="zprFieldFormaterFilters"
        [p-filter-service]="zprService"
        [p-advanced-filters]="zprAdvancedFilters"
        [p-literals]="{ modalTitle: 'Motivo da Reprovação' }"
        [p-required]="true"
        [p-auto-height]="true">
      </po-lookup>
    </form>
  </po-modal>
